// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_0-message {
  /* Typography */
  --perxis-auto-message-font-family-inner: var(
    --perxis-auto-message-font-family,
    var(--perxis-auto-root-typography-main-font-family-inner)
  );
  --perxis-auto-message-font-size-sm-xxl-inner: var(
    --perxis-auto-message-font-size-sm-xxl,
    var(--perxis-auto-root-typography-main-font-size-xxl-inner)
  );
  --perxis-auto-message-font-size-xxs-xs-inner: var(
    --perxis-auto-message-font-size-xxs-xs,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-message-font-weight-inner: var(
    --perxis-auto-message-font-weight,
    var(--perxis-auto-root-typography-main-font-weight-inner)
  );
  --perxis-auto-message-letter-spacing-inner: var(
    --perxis-auto-message-letter-spacing,
    var(--perxis-auto-root-typography-main-letter-spacing-inner)
  );
  --perxis-auto-message-line-height-inner: var(
    --perxis-auto-message-line-height,
    var(--perxis-auto-root-typography-main-line-height-xxl-inner)
  );
  --perxis-auto-message-text-transform-inner: var(
    --perxis-auto-message-text-transform,
    var(--perxis-auto-root-typography-main-text-transform-inner)
  );
  --perxis-auto-message-font-variant-numeric-inner: var(
    --perxis-auto-message-font-variant-numeric,
    var(--perxis-auto-root-typography-main-font-variant-numeric-inner)
  );
  --perxis-auto-message-color-inner: var(
    --perxis-auto-message-color,
    var(--perxis-auto-root-typography-color-lightest-inner)
  );
  --perxis-auto-message-icon-color-inner: var(
    --perxis-auto-message-icon-color,
    var(--perxis-auto-root-typography-color-lightest-inner)
  );
  /* End Typography */
  /* Padding */
  --perxis-auto-message-padding-sm-xxl-inner: var(--perxis-auto-message-padding-sm-xxl, 18px 18px 18px 24px);
  --perxis-auto-message-padding-xxs-xs-inner: var(--perxis-auto-message-padding-xxs-xs, 16px 16px 16px 24px);
  /* End Padding */
  /* Sizes */
  --perxis-auto-message-min-height-inner: var(--perxis-auto-message-min-height, 60px);
  --perxis-auto-message-top-inner: var(--perxis-auto-message-top, 0);
  /* End Sizes */
  /* Colors */
  --perxis-auto-message-background-color-inner: var(
    --perxis-auto-message-background-color,
    var(--perxis-auto-root-third-color-inner)
  );
  /* End Colors */
  /* Box shadow */
  --perxis-auto-message-box-shadow-inner: var(--perxis-auto-message-box-shadow, 0px 0px 20px 0px rgba(22, 22, 22, 0.2));
  /* End Box shadow */
  --antd-wave-shadow-color: transparent;
  --wave-color: transparent;
  user-select: none;
}
.perxis-auto-1_16_0-message[ant-5_17_0-click-animating-without-extra-node=true]::after,
.perxis-auto-1_16_0-message > *[ant-5_17_0-click-animating-without-extra-node=true]::after {
  animation: none !important;
}
.perxis-auto-1_16_0-message .ant-5_17_0-wave {
  transition: none !important;
}
.perxis-auto-1_16_0-message,
.perxis-auto-1_16_0-message .perxis-auto-1_16_0-message__content-col {
  top: var(--perxis-auto-message-top-inner) !important;
  font-family: var(--perxis-auto-message-font-family-inner);
  font-size: var(--perxis-auto-message-font-size-sm-xxl-inner);
  line-height: var(--perxis-auto-message-line-height-inner);
  font-weight: var(--perxis-auto-message-font-weight-inner);
  text-transform: var(--perxis-auto-message-text-transform-inner);
  letter-spacing: var(--perxis-auto-message-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-message-font-variant-numeric-inner);
  color: var(--perxis-auto-message-color-inner);
}
@media (max-width: 575px) {
  .perxis-auto-1_16_0-message,
  .perxis-auto-1_16_0-message .perxis-auto-1_16_0-message__content-col {
    font-size: var(--perxis-auto-message-font-size-xxs-xs-inner);
  }
}
.perxis-auto-1_16_0-message .perxis-auto-1_16_0-message__content-col {
  flex: 0 1 auto;
}
@media (max-width: 575px) {
  .perxis-auto-1_16_0-message .perxis-auto-1_16_0-message__content-col {
    flex: 1 1 auto;
  }
}
.perxis-auto-1_16_0-message .perxis-auto-1_16_0-message-notice-wrapper {
  min-height: var(--perxis-auto-message-min-height-inner);
  padding: var(--perxis-auto-message-padding-sm-xxl-inner) !important;
  background: var(--perxis-auto-message-background-color-inner);
  box-shadow: var(--perxis-auto-message-box-shadow-inner);
  text-align: center;
}
@media (max-width: 575px) {
  .perxis-auto-1_16_0-message .perxis-auto-1_16_0-message-notice-wrapper {
    padding: var(--perxis-auto-message-padding-xxs-xs-inner) !important;
    text-align: start;
  }
}
.perxis-auto-1_16_0-message .perxis-auto-1_16_0-message-notice-wrapper .perxis-auto-1_16_0-message-notice .perxis-auto-1_16_0-message-notice-content {
  width: 100%;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: none;
  box-shadow: none;
  opacity: 0;
  animation: message-content 1.5s forwards;
}
.perxis-auto-1_16_0-message .perxis-auto-1_16_0-message-notice-wrapper .perxis-auto-1_16_0-message-notice .perxis-auto-1_16_0-message-notice-content .anticon.anticon-info-circle {
  display: none;
}
@keyframes message-content {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.perxis-auto-1_16_0-message .perxis-auto-1_16_0-message__icon-col {
  display: flex;
  justify-content: center;
  align-items: center;
}
.perxis-auto-1_16_0-message .perxis-auto-1_16_0-message__cross-icon,
.perxis-auto-1_16_0-message .perxis-auto-1_16_0-message__check-icon {
  color: var(--perxis-auto-message-icon-color-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
